import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import cybersafety from './cybersafety.png';
import { BrowserRouter as Router, Route, Routes, NavLink } from "react-router-dom";
import {
  //Navigation,
  Footer,
  Home,
  About,
  Contact,
  UserManual,
  HowItWorks,
  Scanner,
  URLMalwareScanner
} from "./components";

import { Helmet } from "react-helmet";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageLanguage: "en",
    };
  }

  changeEnglishLanguage = (e) => {
    e.preventDefault();
    console.log('The language is English');
    this.setState({ pageLanguage: 'en' });
    var element = document.getElementById("greekLang");
    element.classList.remove("active");
    var element2 = document.getElementById("englishLang");
    element2.classList.add("active");
  };

  changeGreekLanguage = (e) => {
    e.preventDefault();
    console.log('The language is Greek');
    this.setState({ pageLanguage: 'gr' });
    var element = document.getElementById("englishLang");
    element.classList.remove("active");
    var element2 = document.getElementById("greekLang");
    element2.classList.add("active");
  };

  render() {

    let homeMenu = this.state.pageLanguage == 'en' ? "Home" : "Αρχικη";
    let aboutMenu = this.state.pageLanguage == 'en' ? "About" : "Σχετικα";
    let worksMenu = this.state.pageLanguage == 'en' ? "How it Works" : "Πως δουλευει";
    let tutorialMenu = this.state.pageLanguage == 'en' ? "User Manual" : "Οδηγιες Χρησης";
    let googleMenu = this.state.pageLanguage == 'en' ? "Google Play App Scanner" : "Αναλυση Εφαρμογης απο Google Play";
    let webMenu = this.state.pageLanguage == 'en' ? "URL Malware Scanner" : "Αναλυση Ιστοσελιδας";
    let contactMenu = this.state.pageLanguage == 'en' ? "Contact" : "Επικοινωνια";

    return (
      <Router>
        <div className="navigation" >
          <Helmet>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta name="description" content="" />
            <meta name="author" content="" />
            <title>PrivacySaferIII</title>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script>
            <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
            <script src="https://use.fontawesome.com/releases/v5.12.1/js/all.js" crossorigin="anonymous"></script>

            <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css" />
            <link href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic" rel="stylesheet"
              type="text/css" />
          </Helmet>
          <nav className="navbar navbar-expand-lg bg-secondary text-uppercase" id="mainNav">
            <div className="container">
              <a href="https://www.cybersafety.cy/"> <img src={cybersafety} alt="" className="euroPic" /></a>
              <a className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" href="#">PrivacySaferII</a>
              <div>
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item mx-0 mx-lg-1">
                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/" >
                      {homeMenu}
                      <span className="sr-only">(current)</span>
                    </NavLink>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1">
                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/about">
                      {aboutMenu}
                    </NavLink>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1">
                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/works">
                      {worksMenu}
                    </NavLink>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1">
                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/usermanual">
                      {tutorialMenu}
                    </NavLink>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1">
                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/contact">
                      {contactMenu}
                    </NavLink>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1">

                    <a href="https://privacyanayzer-tool.ey.r.appspot.com/" target="=_blank" className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"><label className="lang"
                      key="privacyanalyzer">PrivacyAnalyzer ToolSet</label></a>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1" >
                    <a id="englishLang" className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger active"
                      href="#" onClick={this.changeEnglishLanguage}>EN</a>
                  </li>
                  <li className="nav-item mx-0 mx-lg-1" >
                    <a id="greekLang" className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                      href="#" onClick={this.changeGreekLanguage}>ΕΛ</a>
                  </li>

                </ul>
              </div>
            </div>
          </nav >
        </div >
        {/* <Navigation /> */}
        <Routes>

          <Route path="/" element={<Home lang={this.state.pageLanguage} />} />
          <Route path="/about" element={<About lang={this.state.pageLanguage} />} />
          <Route path="/works" element={<HowItWorks lang={this.state.pageLanguage} />} />
          <Route path="/contact" element={<Contact lang={this.state.pageLanguage} />} />
          <Route path="/usermanual" element={<UserManual lang={this.state.pageLanguage} />} />


        </Routes>
        <Footer />
      </Router>

    );
  }
}

export default App;